import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { MEDIA_QUERIES } from '../../../constants';
import { Header, ManagePanelIcon } from '../../Header/styled';

export const textOverflowHidden = css`
  white-space: nowrap;
  overflow: hidden;
`;

export const Sidebar = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #172b4d;
  word-break: normal;
  word-wrap: break-word;
  list-style: none;

  z-index: 1;
  height: 100vh;
  height: var(--app-height);
  // padding-top: 52px;
  justify-content: space-between;
  transition: all 0.4s ease;

  .collapsed & {
    width: 0;
    overflow: hidden;
  }

  ${Header} {
    color: white;

    ${ManagePanelIcon} {
      > svg {
        color: #fff;
        fill: transparent;
      }
    }
  }

  ${MEDIA_QUERIES[0]} {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
  }

  ${MEDIA_QUERIES[1]} {
    width: 100%;

    .collapsed & {
      display: none;
    }
  }
`;

export const Menu = styled.ul`
  margin: 0;
  list-style: none;
  text-decoration: none;
  padding: 0;
  flex: 1;
`;

export const MenuItem = styled.li`
  ${textOverflowHidden}
  a {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 13px 20px;
    border-bottom: 1px solid #364663;
    color: rgb(241, 237, 237);
    font-size: 16px;
    position: relative;

    &:hover,
    &.active {
      color: white;
      font-weight: bold;
      border-bottom: 1px solid white;
      &:before {
        display: block;
      }
    }

    &:hover,
    &.active {
      color: white;
      font-weight: bold;
      border-bottom: 1px solid white;
      &:before {
        display: block;
      }
    }

    span {
      margin-right: 8px;
    }
  }
`;

export const Hamburger = styled.div`
  cursor: pointer;

  padding: 10px;

  z-index: 2;

  color: white;

  &:hover {
    opacity: 0.8;
  }
`;

export const Logout = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 10px;

  z-index: 2;

  > svg {
    height: 32px;
    color: white;
    .collapsed & {
      display: none;
    }
  }

  &:hover {
    opacity: 0.8;
  }
`;

export const BoardName = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const Icons = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;
